import { Component, OnInit } from '@angular/core';
import { fadeAnimation } from 'app/shared/animations/route-animations';

@Component({
  selector: 'app-home-content',
  templateUrl: './home-content.component.html',
  styleUrls: ['./home-content.component.scss'],
  animations: [fadeAnimation]

})
export class HomeContentComponent implements OnInit {

  message = false;
  withWindow: number;

  constructor() { }

  ngOnInit(): void {
    this.initComponent();
  }

  showMesssag(): void {
    const countBOat = +sessionStorage.getItem('countBOat') || null;
    let count: number;

    count = countBOat ? countBOat : 1;

    if (count < 3) {
      count++;
      sessionStorage.setItem('countBOat', count.toString());
    } else if (count === 3) {
      this.message = true;
      sessionStorage.clear();
      setTimeout(() => {
        this.message = false;
      }, 3000);
    }



  }

  private moveBoat(): void {
    const { width: screenWidth } = screen;
    let extremLimit;
    let marginAdd;

    if (screenWidth >= 0 && screenWidth <= 375) {
      extremLimit = 80;
      marginAdd = 10;
    } else if (screenWidth > 375 && screenWidth <= 425) {
      extremLimit = 80.5;
      marginAdd = 5;
    } else if (screenWidth > 425 && screenWidth <= 768) {
      extremLimit = 90;
      marginAdd = 5;
    } else if (screenWidth > 768 && screenWidth <= 1024) {
      extremLimit = 94;
      marginAdd = 4;
    } else if (screenWidth > 768 && screenWidth <= 2560) {
      extremLimit = 94;
      marginAdd = 4;
    }

    const contentBoat = document.getElementById('content_boat');
    const messagecontentBoat = document.getElementById('message_boat');
    const boat = document.getElementById('boat');
    let margin = 0;
    const baseLimit = 0;

    sessionStorage.setItem('courseOfBoat', '0');
    let courseOfBoat = +sessionStorage.getItem('courseOfBoat');

    margin += marginAdd;

    const intervalBoat = setInterval(() => {

      contentBoat.style.marginLeft = `${margin}%`;
      if (margin > baseLimit && margin < extremLimit && contentBoat.style.transform !== 'scaleX(-1)') {
        margin += marginAdd;
      } else if (margin >= extremLimit) {
        contentBoat.style.transform = 'scaleX(-1)';
        messagecontentBoat.style.transform = 'scaleX(-1)';
        courseOfBoat++;

        margin -= marginAdd;
      } else if (margin < extremLimit && margin !== baseLimit && contentBoat.style.transform === 'scaleX(-1)') {
        margin -= marginAdd;
      } else if (margin <= baseLimit) {
        contentBoat.style.transform = '';
        contentBoat.style.transform = 'scaleX(1)';
        messagecontentBoat.style.transform = 'scaleX(1)';
        margin += marginAdd;
        courseOfBoat++;
      }

      setTimeout(() => {
        boat.style.transform = 'rotate(-20deg)';
      }, 200);

      setTimeout(() => {
        boat.style.transform = 'rotate(30deg)';
      }, 400);

      setTimeout(() => {
        boat.style.transform = 'rotate(0deg)';
      }, 600);

      if (courseOfBoat === 4) {
        clearInterval(intervalBoat);
        contentBoat.style.marginLeft = '20px';
        setInterval(() => {
          setTimeout(() => {
            boat.style.transform = 'rotate(-20deg)';
          }, 400);

          setTimeout(() => {
            boat.style.transform = 'rotate(30deg)';
          }, 600);

          setTimeout(() => {
            boat.style.transform = 'rotate(0deg)';
          }, 800);
        }, 1800);
      }
    }, 1800);

  }

  private initComponent(): void {
    this.withWindow = window.innerWidth;
    if (this.withWindow > 767) { this.moveBoat(); }
  }

}
